import React, { useState } from 'react';
import CrayonSvg from "../SVG/CrayonSvg";

const EditableText = ({ text, onSave }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentText, setCurrentText] = useState(text);

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
        onSave(currentText);
    };

    return (
        <div>
            {isEditing ? (
                <input
                    type="text"
                    value={currentText}
                    onChange={(e) => setCurrentText(e.target.value)}
                    onBlur={handleSaveClick}
                    autoFocus
                />
            ) : (
                <div onClick={handleEditClick} style={{ display: 'flex', alignItems: 'center' }}>
                    <span className={'mr-5 mt-1 text-sm text-gray-700'}>{currentText}</span>
                    <CrayonSvg />
                </div>
            )}
        </div>
    );
};

export default EditableText;